import {
  useRef,
  useState,
  type FC,
  type PropsWithChildren,
  type ReactNode,
} from "react";
import useEvent from "react-use-event-hook";

import { usePagingStickyEmulationReports } from "@ryde/controls";
import {
  FilterFieldsMobileWrapper,
  PageHeaderMobileSearchButton,
  PageHeaderMobileStyled,
  PanelTopStatReports,
} from "@ryde/layout";

import { useFiltersActiveStateReports } from "../filters";
import { PageHeadersFiltersMobileSidebarReports } from "../footer";

interface IHeaderMobileReportProps extends PropsWithChildren {
  mainTitle: string;
  topWidgetComponent?: ReactNode;
}

export const PageHeaderMobileReports: FC<IHeaderMobileReportProps> = ({
  mainTitle,
  topWidgetComponent,
  children,
}) => {
  const [isFilterSidebarOpen, setIsFilterSidebarOpen] = useState(false);
  const mobileHeaderRef = useRef<HTMLDivElement>(null);
  const mobileHeaderSecondLineRef = useRef<HTMLDivElement>(null);
  usePagingStickyEmulationReports({ pagingRef: mobileHeaderRef });
  usePagingStickyEmulationReports({ pagingRef: mobileHeaderSecondLineRef });

  const onFiltersOpenClick = (): void => {
    setIsFilterSidebarOpen(true);
  };

  const onFiltersApply = useEvent(() => {
    setIsFilterSidebarOpen(false);
  });

  const { isAnyFilterActive } = useFiltersActiveStateReports();

  return (
    <>
      <PageHeaderMobileStyled ref={mobileHeaderRef}>
        {Boolean(topWidgetComponent) && <span>{topWidgetComponent}</span>}
        <div className="buttons-container">
          <PageHeaderMobileSearchButton
            isAnyFilterActive={isAnyFilterActive}
            onClick={onFiltersOpenClick}
          />
        </div>
      </PageHeaderMobileStyled>
      <div
        ref={mobileHeaderSecondLineRef}
        data-e2e="second-line-header-mobile-sticky"
      >
        <PanelTopStatReports />
      </div>

      {isFilterSidebarOpen && (
        <PageHeadersFiltersMobileSidebarReports
          mainTitle={mainTitle}
          onApply={onFiltersApply}
          setIsFilterSidebarOpen={setIsFilterSidebarOpen}
        >
          <FilterFieldsMobileWrapper>{children}</FilterFieldsMobileWrapper>
        </PageHeadersFiltersMobileSidebarReports>
      )}
    </>
  );
};
